import styled from 'styled-components'

import { FONT_SIZE, NATIVE_BASE_COLORS} from '../../../../../themes'

const Style = styled.div`
  .completed {
    padding: 0px 8px;
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.TN};
    color: ${NATIVE_BASE_COLORS.SUCCESS[700]};
    text-align: center;
    background-color: ${NATIVE_BASE_COLORS.SUCCESS[100]};
  }

  .on-going {
    padding: 0px 8px;
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.TN};
    color: ${NATIVE_BASE_COLORS.INFO[700]};
    text-align: center;
    background-color: ${NATIVE_BASE_COLORS.INFO[100]};
  }

  .waiting {
    padding: 0px 8px;
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.TN};
    color: ${NATIVE_BASE_COLORS.WARNING[700]};
    text-align: center;
    background-color: ${NATIVE_BASE_COLORS.WARNING[100]};
  }  
`

export default Style
